export default {"src":"/_next/static/media/village-france.a74ef31b.svg","height":84,"width":75,"blurWidth":0,"blurHeight":0};